"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _products = require("@/api/products");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _excel = require("@/utils/excel");
var _VariationPrice = _interopRequireDefault(require("./components/VariationPrice.vue"));
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _admin = require("@/store/modules/admin");
var _index4 = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _categories = require("@/api/categories");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.category = '';
    this.categoryList = [];
    this.productList = [];
    this.allCategories = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      name: undefined,
      featured: undefined,
      'category.name': undefined,
      'category.id': undefined,
      sort: 'id,DESC',
      filter: {
        name: '$contL',
        enabled: '$eq',
        featured: '$eq',
        'category.name': '$contL',
        'category.id': '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
    this.featuredTypeOptions = [{
      key: true,
      value: 'Featured'
    }, {
      key: false,
      value: 'Not Featured'
    }];
  }
  created() {
    this.getList();
    this.watchQuery();
    this.getAllCategories();
  }
  // Watch for route changes
  watchQuery() {
    this.$watch(() => this.$route.query, () => {
      this.getList();
    }, {
      immediate: true
    });
  }
  async getList() {
    try {
      this.listLoading = true;
      if (this.$route.query.page) {
        this.listQuery.page = +this.$route.query.page;
      } else {
        this.listQuery.page = 1;
      }
      if (this.$route.query.limit) {
        this.listQuery.limit = +this.$route.query.limit;
      }
      const data = await (0, _products.getProducts)((0, _index2.getQuery)(this.listQuery));
      this.list = data.data.map(item => {
        return {
          ...item,
          categoryId: item.categoryId || (item.category ? item.category.id : undefined),
          tagsArray: item.tags ? item.tags.split(',').filter(t => t.trim() !== '') : [],
          updatingCategory: false,
          updatingTags: false
        };
      });
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchCategoryList(query = '', force = false) {
    try {
      if (query.length > 2 || force) {
        this.categoryList = await (0, _categories.getCategories)((0, _index2.getQuery)({
          limit: 10,
          enabled: true,
          name: query || undefined,
          filter: {
            enabled: '$eq',
            name: '$contL'
            // parentId: '$isnull'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchProductList(query = '', force = false) {
    try {
      if (query.length > 1 || force) {
        this.productList = await (0, _products.getProducts)((0, _index2.getQuery)({
          enabled: true,
          name: query || undefined,
          filter: {
            enabled: '$eq',
            name: '$contL'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  onProductSearchEnter(event) {
    const input = event.target.value;
    if (input) {
      this.listQuery.name = input;
      this.handleFilter();
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  async handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Product Name', 'Type', 'Description', 'HSN code'];
    const filterVal = ['id', 'name', 'productType', 'description', 'hsnCode'];
    const productFilter = Object.assign({}, this.listQuery);
    delete productFilter.limit;
    delete productFilter.page;
    const data2 = await (0, _products.getProducts)((0, _index2.getQuery)(productFilter));
    const data = (0, _index2.formatJson)(filterVal, data2);
    (0, _excel.exportJson2Excel)(tHeader, data, this.$tc('route.productManagement.product.title'));
    this.downloadLoading = false;
  }
  isSuperAdmin() {
    // @Todo: Need to change this to id basis.
    return ['Super Admin', 'System Admin', 'Admin'].includes(_admin.AdminModule.roles.toString());
  }
  isSuperAdminOrManager() {
    // @Todo: Need to change this to id basis.
    return ['Super Admin', 'System Admin', 'Admin', 'Sales Manager'].includes(_admin.AdminModule.roles.toString());
  }
  async getAllCategories() {
    try {
      const data = await (0, _categories.getCategories)((0, _index2.getQuery)({
        limit: 1000,
        enabled: true
      }));
      this.allCategories = data;
    } catch (error) {
      console.error('Failed to load categories', error);
    }
  }
  async updateProductCategory(row) {
    try {
      this.$set(row, 'updatingCategory', true);
      await (0, _products.updateProduct)(row.id, {
        categoryId: row.categoryId
      });
      this.$message.success('Category updated successfully');
      // Refresh row's category details
      const category = this.allCategories.find(c => c.id === row.categoryId);
      if (category) {
        row.category = category;
      }
    } catch (error) {
      this.$message.error('Failed to update category: ' + error);
      this.getList();
    } finally {
      this.$set(row, 'updatingCategory', false);
    }
  }
  async updateProductTags(row) {
    try {
      this.$set(row, 'updatingTags', true);
      const tagsString = row.tagsArray.join(',');
      await (0, _products.updateProduct)(row.id, {
        tags: tagsString
      });
      row.tags = tagsString;
      this.$message.success('Tags updated successfully');
    } catch (error) {
      this.$message.error('Failed to update tags: ' + error);
      this.getList();
    } finally {
      this.$set(row, 'updatingTags', false);
    }
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ProductList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default,
    Inr: _index4.default,
    VariationPrice: _VariationPrice.default
  }
})], default_1);
var _default = exports.default = default_1;